import TagManager from 'react-gtm-module';
const GTM_ID=window.weeksWebCloudConfig.REACT_APP_GTM_ID;
const  GTM_DATALAYER_NAME=window.weeksWebCloudConfig.REACT_APP_GTM_DATALAYER_NAME;
export const isGTMEnabled = GTM_ID && GTM_DATALAYER_NAME;
 const  CustomTagManager = (dataLayerArgs) => {
  isGTMEnabled && TagManager.dataLayer(dataLayerArgs);
};
 
export default CustomTagManager;